<ng-container *ngIf="isLoaded()">
  <div class="container-fluid ">
    <ng-container *ngIf="tenderList && tenderList.length > 0; else noTenders">
      <ng-container *ngTemplateOutlet="tenderFilter"></ng-container>
      <ng-container *ngTemplateOutlet="tenderListTemplate"></ng-container>
    </ng-container>
  </div>
</ng-container>
<!-- PANEL DE FILTROS-->
<ng-template #tenderFilter>
  <p-panel [toggleable]="true">
    <p-header>
      <span> {{'General.filters'| translate}}</span>
    </p-header>
    <div class="row">
      <div class="col-12 col-md-1">{{'TenderInfo.company' | translate}}</div>
      <div class="col-12 col-md-5">
        <p-multiSelect defaultLabel="{{ 'General.select' | translate }}" [options]="companyValues" dataKey="identifier"
          optionLabel="description" [(ngModel)]="filter.companies" (onChange)="filterTenderList()">
        </p-multiSelect>
      </div>
      <div class="col-12 col-md-1">{{ 'TenderEvaluation.filter.states' | translate }}:</div>
      <div class="col-12 col-md-5">
        <p-multiSelect defaultLabel="{{ 'General.select' | translate }}" [options]="tenderStates"
          [(ngModel)]="filter.state" (onChange)="filterTenderList()">
        </p-multiSelect>
      </div>
      <div class="col-12 col-md-1 m-t-xs" *ngIf="hasLots">{{ 'TenderEvaluation.filter.lots' | translate }}:</div>
      <div class="col-12 col-md-5 m-t-xs" *ngIf="hasLots">
        <p-multiSelect defaultLabel="{{ 'General.select' | translate }}" [options]="filterLotValues"
          dataKey="identifier" [(ngModel)]="filter.lots" (onChange)="filterTenderList()">
        </p-multiSelect>
      </div>
    </div>
  </p-panel>
</ng-template>
<!--TABLA DE OFERTAS-->
<ng-template #tenderListTemplate>
  <p-overlayPanel [dismissable]="true" #tenderErrors>
    <div class="alert alert-danger" role="alert">
      <ul>
        <li *ngFor="let errorMsg of this.tenderListError">{{errorMsg}}</li>
      </ul>
    </div>
  </p-overlayPanel>
  <p-table [value]="filteredTenderList" sortField="startInfo.date" sortOrder="1" [rows]="20" [paginator]="false"
    [responsive]="true" [pageLinks]="4" [rowsPerPageOptions]="[15, 30, 100]" class="footer-over-pagination mb-3">
    <ng-template pTemplate="header">
      <tr>
        <th class="col-icon" *ngIf="existsErrors()"></th>
        <th class="col-icon"></th>
        <th class="action-column-2x"></th>
        <th class="LONGTEXTTH">{{ colHeaders[0] | translate }}</th>
        <th class="TEXTTH">{{ colHeaders[1] | translate }}</th>
        <th class="LONGTEXTTH" *ngIf="hasLots">{{ colHeaders[2] | translate }}</th>
        <th class="action-button text-right"> {{ colHeaders[3] | translate }} </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-tender let-index="rowIndex">
      <tr (mouseover)="(isTenderInError(index))? showErrors($event, actualTarget, index) : undefined"
        (mouseout)="(isTenderInError(index))? hideErrors() : undefined">
        <td class="col-icon" *ngIf="existsErrors()">
          <ng-container *ngIf="isTenderInError(index)">
            <!-- <a (click)="toggleErrors($event, actualTarget, index)" >  -->
            <i class="fas fa-exclamation-circle text-danger fa-lg" #actualTarget></i>
            <!-- </a> -->
          </ng-container>
        </td>
        <td class="col-icon">
          <span>
            <ng-container
              *ngIf="tender.document?.currentState?.identifier === TenderStateDTOV2.ACCEPTED; else rejectedIcon">
              <i class="far fa-lg fa-thumbs-up text-success"></i>
            </ng-container>
            <ng-template #rejectedIcon>
              <ng-container
                *ngIf="tender.document?.currentState?.identifier === TenderStateDTOV2.REJECTED; else otherIcon">
                <i class="far fa-lg fa-thumbs-down text-danger"></i>
              </ng-container>
            </ng-template>
            <ng-template #otherIcon>
              <i class="fa fa-lg fa-pen"></i>
            </ng-template>
            <span class="sr-only"></span>
          </span>
        </td>
        <td class="action-column-2x"> {{ ((tender.isElectronicTender) ? 'TenderInfo.electronic' :'TenderInfo.paper') |
          translate }} </td>
        <td class="LONGTEXT">
          <span class="p-column-title">{{ colHeaders[0] | translate }}</span>
          <formatDataValue [type]="'TEXT'" [value]="getCompanyDescription(tender)">
          </formatDataValue>
        </td>
        <td class="TEXT">
          <span class="p-column-title">{{ colHeaders[1] | translate }}</span>
          <span
            *ngIf="tender.document?.currentState?.type?.description">{{tender.document?.currentState.type.description}}</span>
          <span *ngIf="!tender.document?.currentState?.type?.description">{{ 'TenderStateDTO.v2.' +
            tender.document.currentState.identifier | translate }}</span>
        </td>
        <td class="LONGTEXT" *ngIf="hasLots">
          <span class="p-column-title">{{ colHeaders[2] | translate }}</span>
          <formatDataValue [type]="'TEXT'" [value]="getTenderLotsDescription(tender)">
          </formatDataValue>
        </td>
        <td>
          <span class="p-column-title">{{ colHeaders[3] | translate }}</span>
          <div class="float-right btn-group d-flex justify-content-end text-right">
            <button class="btn btn-sm btn-secondary t-action-button" aria-expanded="false"
              title="{{'TenderList.actions.editTender' | translate}}" (click)="openTenderEditor(tender, index)">
              <i class="fas fa-pencil-alt" aria-hidden="true"></i>
            </button>
            <button class="btn btn-sm btn-secondary t-action-button" aria-expanded="false"
              title="{{'TenderList.actions.documents' | translate}}" (click)="openTenderDocuments(tender, index)">
              <i class="far fa-file-alt" aria-hidden="true"></i>
            </button>
            <!--Botón de anexado de sobres electrónicos a la oferta. Solo visible si el expediente tiene licitación electrónica y licita con PLYCA-Expedientes.-->
            <button
              *ngIf="project?.classification?.submissionMethodCode && (!project?.classification?.submissionPlatform || project?.classification?.submissionPlatform?.identifier == 'PLYCA<>PLAT_LICITACION')"
              class="btn btn-sm btn-secondary t-action-button" aria-expanded="false"
              title="{{'TenderList.actions.submissions' | translate}}" (click)="openTenderSubmissions(tender)">
              <i class="far fa-envelope" aria-hidden="true"></i>
            </button>
            <!--Botón de borrar oferta. Deshabilitado si la oferta es electrónica o no es editable.-->
            <button
              [attr.disabled]="(tender.isElectronicTender || !task?.work?.context?.configurations?.modeRegisterTendersEnabled?.value) ? 'disabled' : null"
              class="btn btn-sm btn-secondary t-action-button" aria-expanded="false" (click)="deleteTender(tender)"
              title="{{'General.delete' | translate}}">
              <i class="fas fa-times" aria-hidden="true"></i>
            </button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr class="text-center">
        <td colspan="4">{{'TenderEvaluation.filter.noResults' | translate}}</td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>
<!-- TEMPLATE QUE SE MUESTRA CUANDO NO HAY OFERTAS-->
<ng-template #noTenders>
  <ng-container
    *ngTemplateOutlet="tenderMessage;context: { message: this.translateService.instant('TenderEvaluation.noTenders') }">
  </ng-container>
</ng-template>
<!-- TEMPLATE PARA MENSAJES DE CARGA -->
<ng-template #tenderMessage let-message="message">
  <div class="row mt-2">
    <div class="col-12">
      <div class="widget style1 bg-info">
        <div class="row">
          <div class="col-4">
            <i class="fas fa-info fa-3x"></i>
          </div>
          <div class="col-8 text-right">
            <h2 class="font-bold">
              <div>{{message}}</div>
            </h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>